import { render } from "./FormDefaultNewRegistration.vue?vue&type=template&id=311df1d8&scoped=true"
import script from "./FormDefaultNewRegistration.vue?vue&type=script&lang=js"
export * from "./FormDefaultNewRegistration.vue?vue&type=script&lang=js"

import "./FormDefaultNewRegistration.vue?vue&type=style&index=0&id=311df1d8&scoped=true&lang=css"
import "./FormDefaultNewRegistration.vue?vue&type=style&index=1&id=311df1d8&lang=scss"
import "./FormDefaultNewRegistration.vue?vue&type=style&index=2&id=311df1d8&lang=scss"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311df1d8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QField,QCheckbox,QCard,QIcon,QVirtualScroll,QItem,QMenu,QDialog,QStepper,QInput,QSelect});
